<div class="modal-header">
  <button
    type="button"
    class="btn-close"
    (click)="closeModal()"
    aria-label="Close"
  >
    <i class="feather x"></i>
  </button>
  <h4 class="modal-title" id="myModalLabel">Connect Xero Account</h4>
</div>

<div
  class="modal-body"
  style="display: block; background: #fff; overflow: auto"
>
  <div class="loading" *ngIf="loading" style="border-radius: 16px">
    <div class="loader">Loading...</div>
  </div>

  <!-- make a step timeline -->
  @if (step != 4) {
    <div class="step-timeline" style="max-width: 390px; margin: 0 auto 20px">
      <div
        class="step"
        [class.active]="step == 1 || step == 2 || step == 3 || step == 4"
        style="z-index: 4"
      >
        <div class="step-number">1</div>
      </div>
      <div
        class="step"
        [class.active]="step == 2 || step == 3 || step == 4"
        style="z-index: 3"
      >
        <div class="step-number">2</div>
      </div>
      <div
        class="step"
        [class.active]="step == 3 || step == 4"
        style="z-index: 2"
      >
        <div class="step-number">3</div>
      </div>
    </div>
  }

  <div *ngIf="step == 1">
    <div class="form-group">
      <label for="inputCompanyName">Choose Client Workspace</label>
      <input
        [(ngModel)]="selected"
        [typeahead]="workspaces | activeClientsOnly"
        typeaheadOptionField="name"
        container="body"
        (typeaheadOnSelect)="selectWorkspaceForIntegration($event)"
        [typeaheadOptionsLimit]="9999"
        [typeaheadMinLength]="0"
        placeholder="Client Organization Name"
        class="form-control chevron"
      />
      <p class="text-secondary mt-2 fs-7">
        Choose the Client Hub client that this Xero company will be associated
        with.
      </p>
    </div>
    <hr />
    <div class="row">
      <div class="col-md-12">
        <button
          type="button"
          class="btn btn-primary btn-block"
          (click)="step = 2"
          [disabled]="!selected"
        >
          Next
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="step == 2">
    <img
      (click)="launchAuthenticationForm(selectedCompany.id)"
      style="cursor: pointer; margin: 24px auto; display: block"
      src="assets/img/connect-xero-blue.svg"
      alt="Connect to Xero"
    />

    <div class="row mt-2">
      <div class="col-md-6">
        <button
          type="button"
          class="btn btn-default btn-block"
          (click)="step = 1"
        >
          <span>Previous</span>
        </button>
      </div>
      <div class="col-md-6">
        <button
          type="button"
          class="btn btn-primary btn-block"
          [disabled]="!XeroAccountIsIntegrated"
          (click)="goToXeroAccountsSelect()"
        >
          <span>Next</span>
        </button>
      </div>
    </div>

    <!-- <hr>
    <div class="row">
      <div class="col-md-6">
        <button type="button" class="btn btn-default btn-block" (click)="step = 1">
          <span>Previous</span>
        </button>
      </div>
      <div class="col-md-6">
        <button type="button" class="btn btn-primary btn-block" (click)="step = 3">
          <span>Next</span>
        </button>
      </div>
    </div> -->
  </div>

  <div *ngIf="step == 3">
    <div class="modal-qbo-accounts">
      <h4>Choose uncategorized accounts for {{ selectedCompany.name }}</h4>
      <p class="text-secondary mt-2 fs-7">
        Select accounts (like Uncategorized Expense) that we will monitor and
        send transactions to the client to resolve
      </p>

      <ng-template #customItemTemplate let-model="item" let-index="index">
        <div class="xero-accounts-item">
          <div class="name" title="{{ model.path }}">{{ model.Name }}</div>
          <div class="category">
            {{ model.Code }} {{ model.BankAccountType ? "|" : "" }}
            {{ model.BankAccountType }}
          </div>
        </div>
      </ng-template>

      <div class="row d-flex align-items-center">
        <div class="col-md-8">
          <label>Choose Xero accounts</label>
          <input
            [(ngModel)]="selectedAccount.Name"
            [typeahead]="availableAccounts"
            typeaheadOptionField="Name"
            container="body"
            (typeaheadOnSelect)="selectAccount($event)"
            [typeaheadOptionsLimit]="9999"
            [typeaheadMinLength]="0"
            placeholder="Choose Account"
            class="form-control chevron"
            [typeaheadItemTemplate]="customItemTemplate"
          />
        </div>
        <div class="col-md-4">
          <button
            class="btn btn-success btn-block"
            style="margin-top: 24px"
            (click)="addAccountToCompany(selectedCompany.id)"
          >
            Add account
          </button>
        </div>
      </div>

      <h5 style="margin-top: 24px">Selected accounts</h5>
      <div class="options">
        <div class="options-items">
          <div *ngFor="let account of watchedAccounts">
            <div class="account-name">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7363 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2ZM12 20C10.4178 20 8.87104 19.5308 7.55544 18.6518C6.23985 17.7727 5.21447 16.5233 4.60897 15.0615C4.00347 13.5997 3.84504 11.9911 4.15372 10.4393C4.4624 8.88743 5.22433 7.46197 6.34315 6.34315C7.46197 5.22433 8.88743 4.4624 10.4393 4.15372C11.9911 3.84504 13.5997 4.00346 15.0615 4.60896C16.5233 5.21447 17.7727 6.23984 18.6518 7.55544C19.5308 8.87103 20 10.4177 20 12C20 14.1217 19.1572 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20ZM15.82 8.49C15.7265 8.39839 15.6009 8.34707 15.47 8.34707C15.3391 8.34707 15.2135 8.39839 15.12 8.49L10.38 13.23L8.88 11.74C8.83511 11.6922 8.7809 11.654 8.7207 11.628C8.6605 11.6019 8.5956 11.5885 8.53 11.5885C8.46441 11.5885 8.39951 11.6019 8.33931 11.628C8.27911 11.654 8.22489 11.6922 8.18 11.74L7.65 12.27C7.60314 12.3165 7.56594 12.3718 7.54056 12.4327C7.51517 12.4936 7.50211 12.559 7.50211 12.625C7.50211 12.691 7.51517 12.7564 7.54056 12.8173C7.56594 12.8782 7.60314 12.9335 7.65 12.98L10 15.35C10.0449 15.3978 10.0991 15.436 10.1593 15.462C10.2195 15.4881 10.2844 15.5015 10.35 15.5015C10.4156 15.5015 10.4805 15.4881 10.5407 15.462C10.6009 15.436 10.6551 15.3978 10.7 15.35L16.32 9.73C16.3669 9.68352 16.4041 9.62822 16.4295 9.56729C16.4548 9.50636 16.4679 9.44101 16.4679 9.375C16.4679 9.30899 16.4548 9.24364 16.4295 9.18271C16.4041 9.12178 16.3669 9.06648 16.32 9.02L15.82 8.49Z"
                  fill="#2CC93C"
                />
              </svg>
              <div>{{ account.name }}</div>
            </div>
            <i
              class="feather trash color-red"
              style="cursor: pointer"
              (click)="removeAccountFromCompany(account.uuid)"
            ></i>
          </div>
        </div>
      </div>
    </div>
    <hr />
    <div class="row">
      <div class="col-md-6">
        <button
          type="button"
          class="btn btn-default btn-block"
          (click)="step = 2"
        >
          <span>Previous</span>
        </button>
      </div>
      <div class="col-md-6">
        <button
          [disabled]="watchedAccounts.length == 0"
          type="button"
          class="btn btn-primary btn-block"
          (click)="step = 4"
        >
          <span>Finish</span>
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="step == 4">
    <div class="modal-qbo-accounts text-center">
      <div class="my-3 mb-4">
        <svg
          width="81"
          height="80"
          viewBox="0 0 81 80"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M40.5001 6.66667C33.9074 6.66667 27.4627 8.62163 21.9811 12.2843C16.4994 15.9471 12.227 21.153 9.70411 27.2439C7.18119 33.3348 6.52108 40.037 7.80725 46.503C9.09343 52.969 12.2681 58.9085 16.9299 63.5702C21.5916 68.232 27.5311 71.4067 33.9971 72.6929C40.4631 73.979 47.1653 73.3189 53.2562 70.796C59.3471 68.2731 64.553 64.0006 68.2157 58.519C71.8785 53.0374 73.8334 46.5927 73.8334 40C73.8334 35.6226 72.9712 31.2881 71.2961 27.2439C69.6209 23.1997 67.1656 19.5251 64.0703 16.4298C60.975 13.3345 57.3004 10.8792 53.2562 9.20402C49.212 7.52886 44.8775 6.66667 40.5001 6.66667ZM55.0001 32.4333L36.2668 51.1667C36.1171 51.3261 35.9364 51.4532 35.7357 51.54C35.5351 51.6269 35.3188 51.6717 35.1001 51.6717C34.8814 51.6717 34.6651 51.6269 34.4644 51.54C34.2638 51.4532 34.0831 51.3261 33.9334 51.1667L26.0001 43.3333C25.8439 43.1784 25.7199 42.9941 25.6353 42.791C25.5507 42.5879 25.5071 42.37 25.5071 42.15C25.5071 41.93 25.5507 41.7121 25.6353 41.509C25.7199 41.3059 25.8439 41.1216 26.0001 40.9667L27.7668 39.2C27.9164 39.0406 28.0971 38.9135 28.2978 38.8266C28.4984 38.7398 28.7148 38.6949 28.9334 38.6949C29.1521 38.6949 29.3684 38.7398 29.5691 38.8266C29.7697 38.9135 29.9505 39.0406 30.1001 39.2L35.1001 44.1667L50.9001 28.3667C51.2116 28.0613 51.6305 27.8902 52.0668 27.8902C52.503 27.8902 52.9219 28.0613 53.2334 28.3667L55.0001 30.1333C55.2956 30.4433 55.4604 30.8551 55.4604 31.2833C55.4604 31.7116 55.2956 32.1234 55.0001 32.4333Z"
            fill="#2F9139"
            style="
              fill: #2f9139;
              fill: color(display-p3 0.1824 0.57 0.2219);
              fill-opacity: 1;
            "
          />
        </svg>
      </div>
      <h4>Account connected successfully</h4>
      <p class="text-secondary mt-2 fs-7">
        Your Xero connection has been successfully established.  You can see the
        uncategorized items as Client Tasks in the Client Workspace for this
        client.
      </p>
    </div>
    <div class="row mt-5">
      <div class="col-md-12">
        <button
          type="button"
          class="btn btn-default btn-block"
          (click)="closeModal()"
        >
          <span>Close</span>
        </button>
      </div>
    </div>
  </div>
</div>
